/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useCallback, useContext, memo } from 'react';

import initialActions from './actions';

import { IState, IActions } from './dtos';

import { initialState } from './constants';

interface IData {
  data: IState;
  actions: IActions;
}

export const CreateSketchContext = React.createContext<IData>({
  data: initialState,
  actions: initialActions({ data: initialState, setData: () => {} }),
});

export const useCreateSketch = (): IData => useContext(CreateSketchContext);

export default function withCreateSketchProvider(
  WrappedComponent: React.FC,
  state: IState = initialState,
  actions = initialActions,
): React.FC {
  const WithCreateSketch = (props: any) => {
    const [data, setData] = useState(state);

    const value = useCallback(
      () => ({
        data,
        actions: actions({ data, setData }),
      }),
      [data],
    );

    const dataValue: IData = value();

    return (
      <CreateSketchContext.Provider value={dataValue}>
        <WrappedComponent {...props} />
      </CreateSketchContext.Provider>
    );
  };

  return memo(WithCreateSketch);
}
